
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/110w-solar-panel",
      function () {
        return require("private-next-pages/110w-solar-panel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/110w-solar-panel"])
      });
    }
  